import Swal from 'sweetalert2'
import Dropzone from 'dropzone'

import { RcnHtml } from './RcnHtml'
import {
  makeAjaxCall,
  makeOnchageAjaxCall,
  handleDataOfDelay,
  handleOldDataOfDelay,
  sweetAlertCommonParams,
} from '../../utils/functions'
import { lang } from '../../assets/lang'

const page_table_id = window.xitFlowBuilderData.page_table_id
const base_url = window.xitFlowBuilderData.base_url
const instagram_addon = window.xitFlowBuilderData.instagram_addon

var media_type = 'fb';
if (instagram_addon) media_type = 'ig';

export const RcnModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.Rcn_modal_title,
    html: RcnHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      const rcnTitleElement = $('#rcn-title')
      const rcnPostbackElement = $('#rcn-postbackId')
      $('#rcn-recursion-type').val(oldData.rcnRecursionType || 'daily').trigger('change');
      const rcn_type = $("#rcn-recursion-type").val();

      rcnTitleElement.val(oldData.rcnTitleValue || '')

      rcnPostbackElement.on('change', function() {
        Swal.resetValidationMessage()
        const currentValue = $(this).val()
        if ('newRcn' === oldData.rcnPostbackIdValue && 'newRcn' !== currentValue) {
          node.rcnPostbackIdValueChangeStatus = true
          Swal.showValidationMessage(lang.Rcn_html_sequence_info)
        }
      })

      const ajaxRcnData = {
        url: base_url+'visual_flow_builder/get_dropdown_rcn',
        data: {
          page_table_id,rcn_type,media_type
        }
      }

      makeAjaxCall(function(response) {
        $("#rcn-postbackId").html(response.dropdown_str);
        $('#rcn-postbackId').val(oldData.rcnPostbackIdValue || '').trigger('change');
        
      }, ajaxRcnData)

      $("#rcn-recursion-type").on('change', function() {
        const rcn_type = $(this).val();
        ajaxRcnData.data.rcn_type = rcn_type;
        makeOnchageAjaxCall(function(response) {
          $("#rcn-postbackId").html(response.dropdown_str);
          $('#rcn-postbackId').val(oldData.rcnPostbackIdValue || '').trigger('change');
        }, ajaxRcnData)
      })

      // image upload section
      const fileUploadMediaUrlElement = $('#file-upload-media-url')
      fileUploadMediaUrlElement.val(oldData.file || '')

      let serverGeneratedFilename = ''
      Dropzone.autoDiscover = false
      window.flowBuilderUploadedFile = {}
      // var base_url = window.xitFlowBuilderData.base_url

      // eslint-disable-next-line
      const uploadImgDropzone = new Dropzone("#file-upload-dropzone", {
        url: base_url+'visual_flow_builder/flow_builder_upload_media',
        maxFilesize: 5,
        uploadMultiple: false,
        paramName: "media_file",
        createImageThumbnails: true,
        acceptedFiles: ".png, .jpg, .jpeg, .gif, .JPEG, .JPG, .PNG, .GIF",
        maxFiles: 1,
        addRemoveLinks: true,

        // eslint-disable-next-line
        success: async function(file, response) {
          // Display message if error
          if (false === response.status) {
            await Swal.fire({
              icon: 'error',
              text: response.message,
              title: 'Error!',
            });

            return
          }

          if (response.status) {
            serverGeneratedFilename = response.file
            window.flowBuilderUploadedFile = {
              file: response.file
            }

            fileUploadMediaUrlElement.val(response.file)
          }
        },

        // eslint-disable-next-line
        removedfile: function(file) {
          if (window.flowBuilderUploadedFile.file === serverGeneratedFilename) {
            // eslint-disable-next-line
            const result = deleteUploadedFile(serverGeneratedFilename)
              .then(response => {
                if (response.status) {
                  window.flowBuilderUploadedFile = {}
                  fileUploadMediaUrlElement.val('')
                  $('#file-upload-dropzone .dz-preview').remove()
                  Dropzone.forElement('#file-upload-dropzone').removeAllFiles(true)
                }
              }).catch(error => {
                if (error.status !== '200' && error.statusText) {
                  const message = error.status + ' ' + error.statusText
                  alert(message)
                } else {
                  console.log(error)
                }
              })
          }
        },
      })

      const deleteUploadedFile = async (file) => {
        return await $.ajax({
          type: 'POST',
          url: base_url+'visual_flow_builder/flow_builder_delete_media',
          dataType: 'JSON',
          data: { file }, 
        })
      }

      // Handles old data of delay system
      handleOldDataOfDelay(oldData)

      // Removes previous files if there is any
      Dropzone.forElement('#file-upload-dropzone').removeAllFiles(true)
    },

    preConfirm: () => {
      const rcnRecursionType = $('#rcn-recursion-type').val()
      const rcnTitleValue = $('#rcn-title').val()
      const rcnPostbackIdValue = $('#rcn-postbackId').val()
      const rcnPostbackIdText = $( "#rcn-postbackId option:selected" ).text()
      
      if (! rcnTitleValue) {
        Swal.showValidationMessage(lang.Rcn_modal_msg_title)
      }
      
      if (! rcnPostbackIdValue) {
        Swal.showValidationMessage(lang.Rcn_modal_msg_postback_id)
      }

      // image upload section
      const fileData = window.flowBuilderUploadedFile
      const uploadedUrl = $('#file-upload-media-url').val()
      
      if ((0 === Object.values(fileData).length) && node.data.file) {
        fileData.file = node.data.file
      }
      
      if (uploadedUrl) {
        fileData.file = uploadedUrl
      }
      
      if (! uploadedUrl && (Object.values(fileData).length !== 1)) {
        Swal.showValidationMessage(lang.image_modal_msg_image)
      }

      // Handles data of delay system
      const delayData = handleDataOfDelay()

      return {
        ...fileData,
        rcnTitleValue, 
        rcnPostbackIdValue, 
        rcnPostbackIdText, 
        rcnRecursionType,
        ...delayData,
      }
    },
  })
}